<template>
  <v-container fluid>
    <v-row justify="space-between" class="px-10">
      <v-col cols="12" sm="12" md="4">
        <p class="text-h6 text--secondary font-weight-bold">Exercises</p>
        <!-- <v-btn @click="throwQuery()" color="primary">Throw query</v-btn> -->
      </v-col>
      <v-col cols="12" sm="12" md="2">
        <v-btn text color="secondary" @click="createExcercise()">
          <v-icon left dark color="primary"> mdi-plus-circle </v-icon>
          New excercise
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-text-field
          label="Search for a exercises"
          v-model="search"
          single-line
          outlined
          rounded
          filled
          dense
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-data-table
          :search="search"
          :loading="loading"
          :headers="headers"
          :items="getExercises"
          fixed-header
          item-key="tableId"
          class="elevation-4"
          :page.sync="page"
          @update:page="onPageChange"
          :items-per-page.sync="itemsPerPage"
          @update:items-per-page="onItemsPerPageUpdate"
          :sortBy.sync="sortBy"
          @update:sortBy="onSortByChange"
        >
          <template v-slot:[`item.imagePreview`]="{ item }">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on, attrs }">
                <v-avatar class="my-2">
                  <img
                    v-if="getPreviewImage(item)"
                    v-bind="attrs"
                    v-on="on"
                    style="cursor: pointer"
                    @click="openDialogPreviewImage(getPreviewImage(item))"
                    :src="getPreviewImage(item)"
                  />
                </v-avatar>
              </template>
              <span>Show Image</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.videoPreview`]="{ item }">
            <v-tooltip top color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="primary"
                  @click="openDialogPreviewVideo(item)"
                >
                  <v-icon>mdi-message-video</v-icon>
                </v-btn>
              </template>
              <span>Show Video</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.name.ENG`]="{ item }">
            <div
              v-if="!editingName[item.id]"
              class="nameSlot editable-field"
              @click="startEditingName(item)"
            >
              {{ item.name && item.name["ENG"] ? item.name["ENG"] : "No name" }}
            </div>
            <v-text-field
              v-else
              v-model="editingNameValue[item.id]"
              @keyup.enter="handleEnterKey($event, item, 'name')"
              @keyup.esc="cancelEditingName(item)"
              @blur="cancelEditingName(item)"
              dense
              outlined
              hide-details
              class="editable-input"
              ref="nameInput"
            ></v-text-field>
          </template>
          <template v-slot:[`item.description.ENG`]="{ item }">
            <div
              v-if="!editingDescription[item.id]"
              class="descriptionSlot editable-field"
              @click="startEditingDescription(item)"
            >
              <span
                class="d-block text-truncate mx-auto"
                style="max-width: 300px !important"
              >
                {{
                  item.description && item.description["ENG"]
                    ? item.description["ENG"]
                    : "--"
                }}
              </span>
            </div>
            <v-textarea
              v-else
              v-model="editingDescriptionValue[item.id]"
              @keyup.enter="handleEnterKey($event, item, 'description')"
              @keyup.esc="cancelEditingDescription(item)"
              @blur="cancelEditingDescription(item)"
              dense
              outlined
              hide-details
              class="editable-input"
              auto-grow
              rows="2"
              ref="descriptionInput"
            ></v-textarea>
          </template>
          <template v-slot:[`item.isReactNativeExercise`]="{ item }">
            <h4 v-if="item.isReactNativeExercise" class="primary--text">
              New App
            </h4>
            <template v-else>
              <h4 class="secondary--text">Old App</h4>
            </template>
          </template>
          <template v-slot:[`item.difficulty`]="{ item }">
            <div
              v-if="!editingDifficulty[item.id]"
              class="editable-field"
              @click="startEditingDifficulty(item)"
            >
              {{ getDifficultyName(item.difficulty) }}
            </div>
            <div v-else>
              <v-select
                v-model="item.difficulty"
                :items="listDifficulty"
                item-text="name"
                item-value="value"
                @blur="saveDifficulty(item)"
                @change="saveDifficulty(item)"
                dense
                outlined
                hide-details
                class="editable-input"
                ref="difficultyInput"
              ></v-select>
            </div>
          </template>
          <template v-slot:[`item.goal`]="{ item }">
            <div
              v-if="!editingGoal[item.id]"
              class="editable-field"
              @click="startEditingGoal(item)"
            >
              {{ getGoalName(item.goal) }}
            </div>
            <div v-else>
              <v-select
                v-model="item.goal"
                :items="listGoal"
                item-text="name"
                item-value="value"
                @blur="saveGoal(item)"
                @change="saveGoal(item)"
                dense
                outlined
                hide-details
                class="editable-input"
                ref="goalInput"
              ></v-select>
            </div>
          </template>
          <template v-slot:[`item.type`]="{ item }">
            <div
              v-if="!editingType[item.id]"
              class="editable-field"
              @click="startEditingType(item)"
            >
              {{ getTypeName(item.type) }}
            </div>
            <div v-else>
              <v-select
                v-model="item.type"
                :items="listType"
                item-text="name"
                item-value="value"
                @blur="saveType(item)"
                @change="saveType(item)"
                dense
                outlined
                hide-details
                class="editable-input"
                ref="typeInput"
              ></v-select>
            </div>
          </template>
          <template v-slot:[`item.genBodyArea`]="{ item }">
            <div
              v-if="!editingGenBodyArea[item.id]"
              class="editable-field"
              @click="startEditingGenBodyArea(item)"
            >
              {{ getGenBodyAreaName(item.genBodyArea) }}
            </div>
            <div v-else>
              <v-select
                v-model="item.genBodyArea"
                :items="listGenBodyArea"
                item-text="name"
                item-value="value"
                @blur="saveGenBodyArea(item)"
                @change="saveGenBodyArea(item)"
                dense
                outlined
                hide-details
                class="editable-input"
                ref="genBodyAreaInput"
              ></v-select>
            </div>
          </template>
          <template v-slot:[`item.specMuscleGr`]="{ item }">
            <div
              v-if="!editingSpecMuscleGr[item.id]"
              class="editable-field"
              @click="startEditingSpecMuscleGr(item)"
            >
              {{ getSpecMuscleGrName(item.specMuscleGr) }}
            </div>
            <div v-else>
              <v-select
                v-model="item.specMuscleGr"
                :items="listSpecMuscleGr"
                item-text="name"
                item-value="value"
                @blur="saveSpecMuscleGr(item)"
                @change="saveSpecMuscleGr(item)"
                dense
                outlined
                hide-details
                class="editable-input"
                ref="specMuscleGrInput"
              ></v-select>
            </div>
          </template>
          <template v-slot:[`item.oneGymPlacement`]="{ item }">
            <div
              v-if="!editingOneGymPlacement[item.id]"
              class="editable-field"
              @click="startEditingOneGymPlacement(item)"
            >
              {{ getOneGymPlacementName(item.oneGymPlacement) }}
            </div>
            <div v-else>
              <v-select
                v-model="item.oneGymPlacement"
                :items="listOneGymPlacement"
                item-text="name"
                item-value="value"
                @blur="saveOneGymPlacement(item)"
                @change="saveOneGymPlacement(item)"
                dense
                outlined
                hide-details
                class="editable-input"
                ref="oneGymPlacementInput"
              ></v-select>
            </div>
          </template>
          <template v-slot:[`item.accessory`]="{ item }">
            <div
              v-if="!editingAccessory[item.id]"
              class="editable-field"
              @click="startEditingAccessory(item)"
            >
              {{ getAccessoryName(item.accessory) }}
            </div>
            <div v-else>
              <v-select
                v-model="item.accessory"
                :items="listAccessory"
                item-text="name"
                item-value="value"
                @blur="saveAccessory(item)"
                @change="saveAccessory(item)"
                dense
                outlined
                hide-details
                class="editable-input"
                ref="accessoryInput"
              ></v-select>
            </div>
          </template>
          <template v-slot:[`item.twoHands`]="{ item }">
            <div
              v-if="!editingTwoHands[item.id]"
              class="editable-field"
              @click="startEditingTwoHands(item)"
            >
              {{ getTwoHandsName(item.twoHands) }}
            </div>
            <div v-else>
              <v-select
                v-model="item.twoHands"
                :items="listTwoHands"
                item-text="name"
                item-value="value"
                @blur="saveTwoHands(item)"
                @change="saveTwoHands(item)"
                dense
                outlined
                hide-details
                class="editable-input"
                ref="twoHandsInput"
              ></v-select>
            </div>
          </template>
          <template v-slot:[`item.enabled`]="{ item }">
            <v-switch
              v-if="item"
              class="center-switch"
              color="primary"
              :input-value="item.enabled"
              @click="disableExercise(item)"
              flat
            ></v-switch>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <options-button
              :onEdit="
                () => {
                  changeRouteEditExercise(item);
                }
              "
              :onDuplicate="undefined"
              :onDelete="
                () => {
                  openDialogConfirm(item);
                }
              "
              :itemId="item.id"
              :key="item.id"
            />
          </template>
          <!-- <template v-slot:footer="{}">
            <v-row justify="end">
              <v-col cols="1">
                <v-select
                  class="mr-auto"
                  v-model="itemsPerPage"
                  :items="[5,10,15,20,30]"
                >
               </v-select>
              </v-col>
              <v-col cols="2" class="text-right mr-3" align-self="center">
              <v-btn color="primary" x-small class="mx-1" :disabled="pageCounter === 1" @click="goPrevPage()">
                <v-icon size="15">
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <p class="d-inline">{{ pageCounter }}</p>
              <v-btn color="primary" x-small class="mx-1" :disabled="getExercises.length < itemsPerPage || getExercises.length === 0" @click="goNextPage()">
                <v-icon size="15">
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              </v-col>
            </v-row>
          </template> -->
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogPreviewVideo.show"
      transition="dialog-bottom-transition"
      max-width="700"
    >
      <v-card class="text-center">
        <v-card-actions class="pa-0">
          <v-btn
            icon
            color="secondary"
            class="ml-3 mt-2"
            @click="closeDialogVideoPreview()"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <img
          src="@/assets/logo_x.png"
          style="vertical-align: middle"
          class="mx-2 d-inline"
          width="20"
        />
        <p class="font-weight-bold secondary--text d-inline">
          {{ dialogPreviewVideo.name }}
        </p>
        <v-card-text class="pb-8 mt-3">
          <video
            v-if="dialogPreviewVideo.video"
            ref="listProTrainVideoPreview"
            width="100%"
            height="350px"
            controls
            class="mx-auto"
            :src="dialogPreviewVideo.video ? dialogPreviewVideo.video : ''"
          ></video>
          <!-- <v-btn @click="closeDialogVideoPreview()">
              Close
            </v-btn> -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPreviewImage.show" max-width="800">
      <v-card style="line-height: 0; !important;">
        <v-btn
          fab
          x-small
          color="red"
          style="position: absolute; top: 5px; left: 5px"
          @click="closeDialogImagePreview()"
        >
          <v-icon size="15" color="white">mdi-close</v-icon>
        </v-btn>
        <img :src="dialogPreviewImage.img" style="width: 100%; height: 100%" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.show" width="300" class="rounded-xl">
      <v-card class="text-center">
        <!-- <v-card-title class="headline">Use Google's location service?</v-card-title> -->
        <v-icon class="text-center ma-2" size="120" color="primary"
          >mdi-alert</v-icon
        >
        <v-card-text class="pa-4 text-center"
          >This action is irreversible and will delete all data about the
          Excercise. Including the video, image, connection with PWO and
          information</v-card-text
        >
        <v-card-text class="text-center">Are you sure?</v-card-text>

        <!-- <v-card-actions class="pa-0"> -->
        <!-- <v-spacer></v-spacer> -->

        <v-btn
          color="third"
          tile
          width="150"
          class="pa-0 text--secondary"
          @click="closeDialogConfirm()"
          >No</v-btn
        >

        <v-btn
          color="primary"
          tile
          width="150"
          class="pa-0"
          @click="openDialogReAuth('deleteExercise', dialog.item)"
          >Yes</v-btn
        >
        <!-- </v-card-actions> -->
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.snackbar"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      >{{ snackbar.text }}</v-snackbar
    >
    <modal-reauth
      :dialogReAuth="dialogReAuth"
      @isSuccessReAuth="isSuccessReAuth"
    ></modal-reauth>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import modalReauth from "@/components/admin/modal-reauth.vue";
import OptionsButton from "@/components/admin/OptionsButton.vue";
export default {
  name: "Exercises",
  components: { modalReauth, OptionsButton },
  data: () => ({
    search: "",
    headers: [
      // { text: "Video", align: "center", value: "image", sortable: false },
      { text: "", align: "center", value: "imagePreview", sortable: false },
      {
        text: "Preview",
        align: "center",
        value: "videoPreview",
        sortable: false,
      },
      // { text: "Order Number", align: "center", value: "orderNumber", sortable: true },
      { text: "Name", align: "center", value: "name.ENG", sortable: true },
      {
        text: "Description",
        align: "center",
        value: "description.ENG",
        sortable: true,
      },
      {
        text: "Difficulty",
        align: "center",
        value: "difficulty",
        sortable: true,
      },
      {
        text: "Goal",
        align: "center",
        value: "goal",
        sortable: true,
      },
      {
        text: "Type",
        align: "center",
        value: "type",
        sortable: true,
      },
      {
        text: "Body Area",
        align: "center",
        value: "genBodyArea",
        sortable: true,
      },
      {
        text: "Muscle Gr",
        align: "center",
        value: "specMuscleGr",
        sortable: true,
      },
      {
        text: "Placement",
        align: "center",
        value: "oneGymPlacement",
        sortable: true,
      },
      {
        text: "Accessory",
        align: "center",
        value: "accessory",
        sortable: true,
      },
      // { text: "Available On", align: "start", value: "isReactNativeExercise", sortable: true },
      // { text: "Collection", align: "start", value: "collectionName", sortable: true },
      {
        text: "Two Hands",
        align: "center",
        value: "twoHands",
        sortable: false,
      },
      { text: "Enabled", align: "center", value: "enabled", sortable: false },
      { text: "Actions", align: "center", value: "action", sortable: false },
    ],
    loading: true,
    itemsPerPage: 10,
    pageCounter: 1,
    options: {},
    dialogPreviewVideo: {
      show: false,
      video: "",
      name: "",
    },
    dialogPreviewImage: {
      show: false,
      video: "",
    },
    dialogReAuth: {
      show: false,
      action: "",
      item: {},
    },
    dialog: {
      show: false,
      item: {},
    },
    snackbar: {
      snackbar: false,
      timeout: 2000,
      text: null,
      color: "",
    },
    page: 0,
    itemsPerPage: 10,
    sortBy: "name.ENG",
    listDifficulty: [
      {
        name: "Easy",
        value: 1,
      },
      {
        name: "Mid",
        value: 2,
      },
      {
        name: "Hard",
        value: 3,
      },
    ],
    listGoal: [
      {
        name: "Burn",
        value: 1,
      },
      {
        name: "Tone",
        value: 2,
      },
      {
        name: "Build",
        value: 3,
      },
    ],
    listType: [
      {
        name: "Resistance",
        value: 1,
      },
      {
        name: "Suspension",
        value: 2,
      },
      {
        name: "Plyometrics",
        value: 3,
      },
      {
        name: "Stretch",
        value: 4,
      },
    ],
    listGenBodyArea: [
      {
        name: "Upper Body",
        value: 1,
      },
      {
        name: "Lower Body",
        value: 2,
      },
      {
        name: "Full Body",
        value: 3,
      },
      {
        name: "Core",
        value: 4,
      },
    ],
    listSpecMuscleGr: [
      {
        name: "Arms",
        value: 1,
      },
      {
        name: "Legs",
        value: 2,
      },
      {
        name: "Abs",
        value: 3,
      },
      {
        name: "Chest",
        value: 4,
      },
      {
        name: "Lower Back",
        value: 5,
      },
      {
        name: "Upper Back",
        value: 6,
      },
      {
        name: "Shoulders",
        value: 7,
      },
      {
        name: "Hips",
        value: 8,
      },
      {
        name: "Full Body",
        value: 9,
      },
    ],
    listOneGymPlacement: [
      {
        name: "None",
        value: "",
      },
      {
        name: "Floor",
        value: 1,
      },
      {
        name: "Upper Track/Door",
        value: 2,
      },
      {
        name: "Mid Track/Door",
        value: 5,
      },
      {
        name: "Lower Track/Door",
        value: 3,
      },
      {
        name: "Bench",
        value: 4,
      },
    ],
    listAccessory: [
      {
        name: "None",
        value: "",
      },
      {
        name: "Long/Short Bar",
        value: 1,
      },
      {
        name: "Handles",
        value: 2,
      },
      {
        name: "Suspension Handles",
        value: 3,
      },
      {
        name: "Ankle Straps",
        value: 4,
      },
      {
        name: "Jump Belt",
        value: 5,
      },
      {
        name: "Bench",
        value: 6,
      },
    ],
    listTwoHands: [
      {
        name: "Yes",
        value: true,
      },
      {
        name: "No",
        value: false,
      },
    ],
    // Editing state objects
    editingName: {},
    editingNameValue: {},
    editingDescription: {},
    editingDescriptionValue: {},
    editingDifficulty: {},
    editingGoal: {},
    editingType: {},
    editingGenBodyArea: {},
    editingSpecMuscleGr: {},
    editingOneGymPlacement: {},
    editingAccessory: {},
    editingTwoHands: {},
    // Original values for comparison
    originalName: {},
    originalDescription: {},
    originalDifficulty: {},
    originalGoal: {},
    originalType: {},
    originalGenBodyArea: {},
    originalSpecMuscleGr: {},
    originalOneGymPlacement: {},
    originalAccessory: {},
    originalTwoHands: {},
  }),
  created() {
    let vm = this;
    vm.getExercisesList();
    if (this.$route.params.previousRoute === "Edit Exercise") {
      const tableState = localStorage.getItem("exercisesTableState");
      if (tableState) {
        const tableStateObj = JSON.parse(tableState);
        this.search = tableStateObj.query;
        this.itemsPerPage = tableStateObj.hitsPerPage;
        this.page = tableStateObj.page;
      }
    } else {
      this.itemsPerPage = -1;
    }
  },
  methods: {
    async getExercisesList() {
      let vm = this;
      vm.loading = true;

      try {
        await vm.$store.dispatch("GetExercises");
        await vm.$store.dispatch("GetExercisesNew");
        vm.pageCounter = 1;
        vm.loading = false;
      } catch (error) {
        console.error(err);
        vm.loading = false;
      }
    },
    async getExercisesNewList() {
      const vm = this;
      try {
        await vm.$store.dispatch("GetExercisesNew");
      } catch (error) {
        console.error(error);
      }
    },
    getFirstPage() {
      let vm = this;
      vm.$store
        .dispatch("GetExercisesListPaginatedFirstPage", vm.itemsPerPage)
        .then((res) => {
          vm.pageCounter = 1;
          vm.loading = false;
        })
        .catch((err) => {
          console.error(err);
          vm.loading = false;
        });
    },
    goNextPage() {
      let vm = this;
      vm.$store
        .dispatch("GetExercisesNextPage", vm.itemsPerPage)
        .then((res) => {
          if (res.length > 0) {
            vm.pageCounter = vm.pageCounter + 1;
          }
          vm.loading = false;
        })
        .catch((err) => {
          console.error(err);
          vm.loading = false;
        });
    },
    goPrevPage() {
      let vm = this;
      vm.$store
        .dispatch("GetExercisesPrevPage", vm.itemsPerPage)
        .then((res) => {
          vm.pageCounter = vm.pageCounter - 1;
          vm.loading = false;
        })
        .catch((err) => {
          console.error(err);
          vm.loading = false;
        });
    },
    changeRouteEditExercise(item) {
      let vm = this;
      vm.$router.push({ name: "Edit Exercise", params: item }).catch((err) => {
        vm.snackbar.text =
          "Sorry, you don't have permissions to enter this view.";
        vm.snackbar.color = "red darken-2";
        vm.snackbar.snackbar = true;
      });
    },
    getPreviewImage(excercise) {
      const images = [
        "imageShaunaLink",
        "imageAlexLink",
        "imageJustinLink",
        "imageVeonLink",
      ];
      let image = "";
      for (let i = 0; i < images.length; i++) {
        const trainer = images[i];
        if (excercise[trainer]) {
          image = excercise[trainer];
          break;
        }
      }
      if (image === "" && excercise.trainersList.length > 0) {
        for (let i = 0; i < excercise.trainersList.length; i++) {
          const trainer = excercise.trainersList[i];
          if (trainer.exImage && trainer.exImage.link) {
            image = trainer.exImage.link;
            break;
          }
        }
      }
      return image;
    },
    getPreviewVideo(excercise) {
      const videos = [
        "videoShaunaLink",
        "videoAlexLink",
        "videoJustinLink",
        "videoVeonLink",
      ];
      let video = "";
      for (let i = 0; i < videos.length; i++) {
        const trainer = videos[i];
        if (excercise[trainer]) {
          video = excercise[trainer];
          break;
        }
      }
      if (video === "" && excercise.trainersList.length > 0) {
        for (let i = 0; i < excercise.trainersList.length; i++) {
          const trainer = excercise.trainersList[i];
          if (trainer.exVideo && trainer.exVideo.link) {
            video = trainer.exVideo.link;
            break;
          }
        }
      }
      return video;
    },
    openDialogPreviewVideo(excercise) {
      const vm = this;
      const video = vm.getPreviewVideo(excercise);
      vm.dialogPreviewVideo = {
        show: true,
        video: video ? video : "",
        name: excercise.name["ENG"],
      };
    },
    closeDialogVideoPreview() {
      const vm = this;
      vm.dialogPreviewVideo = {
        show: false,
        video: "",
        name: "",
      };
    },
    openDialogPreviewImage(img) {
      const vm = this;
      vm.dialogPreviewImage = {
        show: true,
        img: img ? img : "",
      };
    },
    closeDialogImagePreview() {
      const vm = this;
      vm.dialogPreviewImage.show = false;
      // vm.dialogPreviewImage = {
      //   show: false,
      //   img: ''
      // }
    },
    async disableExercise(exercise) {
      const vm = this;
      const { collectionName, enabled, id, name } = exercise;
      await vm.$store.dispatch("DisableExercise", {
        id,
        collectionName,
        enabled,
      });
      await vm.$store.dispatch("GenerateLog", {
        id: id,
        title: name["ENG"],
        type: "editedExercise",
      });

      let emitData = {
        snackbar: true,
        btn: "",
        y: "bottom",
        x: null,
        mode: "",
        timeout: 2000,
        text: "Exercise edited successfully",
        color: "success",
      };
      vm.$emit("showSnackBar", emitData);
      vm.getExercisesList();
    },
    deleteExercise(exercise) {
      const vm = this;
      vm.$emit("showOverlay", true);
      vm.$store
        .dispatch("DeleteExercise", exercise)
        .then((res) => {
          vm.$store.dispatch("GenerateLog", {
            id: exercise.id,
            title: exercise.name.ENG,
            type: "deletedExercise",
          });
          vm.getExercisesList();
          vm.$emit("showOverlay", false);
          // vm.loading = false;
        })
        .catch((err) => {
          vm.$emit("showOverlay", false);
          console.error(err);
          let emitData = {
            snackbar: true,
            btn: "",
            y: "bottom",
            x: null,
            mode: "",
            timeout: 2000,
            text: "Error deleting Exercise",
            color: "red",
          };
          vm.$emit("showSnackBar", emitData);
        });
    },
    openDialogConfirm(item) {
      let vm = this;
      vm.dialog.show = true;
      vm.dialog.item = item;
    },
    closeDialogConfirm() {
      let vm = this;
      vm.dialog.show = false;
      vm.dialog.item = "";
    },
    isSuccessReAuth(dialogReAuthResponse) {
      const vm = this;
      switch (dialogReAuthResponse.action) {
        case "deleteExercise":
          vm.deleteExercise(dialogReAuthResponse.item);
          break;
        default:
          break;
      }
    },
    openDialogReAuth(action, item) {
      let vm = this;
      vm.dialogReAuth.show = true;
      vm.dialogReAuth.action = action;
      vm.dialogReAuth.item = item;
      vm.closeDialogConfirm();
    },
    createExcercise() {
      let vm = this;
      vm.$router.push({ name: "Create Excercise" }).catch((err) => {
        vm.snackbar.text =
          "Sorry, you don't have permissions to enter this view.";
        vm.snackbar.color = "red darken-2";
        vm.snackbar.snackbar = true;
      });
    },
    onPageChange(page) {
      console.log(page);
    },
    onItemsPerPageUpdate(items) {
      console.log(items);
    },
    onSortByChange(sortBy, test) {
      console.log(sortBy, test);
    },
    // Helper methods to get display names
    getDifficultyName(value) {
      const option = this.listDifficulty.find((item) => item.value === value);
      return option ? option.name : "--";
    },
    getGoalName(value) {
      const option = this.listGoal.find((item) => item.value === value);
      return option ? option.name : "--";
    },
    getTypeName(value) {
      const option = this.listType.find((item) => item.value === value);
      return option ? option.name : "--";
    },
    getGenBodyAreaName(value) {
      const option = this.listGenBodyArea.find((item) => item.value === value);
      return option ? option.name : "--";
    },
    getSpecMuscleGrName(value) {
      const option = this.listSpecMuscleGr.find((item) => item.value === value);
      return option ? option.name : "--";
    },
    getOneGymPlacementName(value) {
      const option = this.listOneGymPlacement.find(
        (item) => item.value === value
      );
      return option ? option.name : "--";
    },
    getAccessoryName(value) {
      const option = this.listAccessory.find((item) => item.value === value);
      return option ? option.name : "--";
    },
    getTwoHandsName(value) {
      const option = this.listTwoHands.find((item) => item.value === value);
      return option ? option.name : "--";
    },
    // Keyboard event handler
    handleEnterKey(event, item, fieldType) {
      // Prevent default behavior and save
      event.preventDefault();

      if (fieldType === "name") {
        this.saveName(item);
      } else if (fieldType === "description") {
        this.saveDescription(item);
      }
    },
    // Start editing methods
      startEditingName(item) {
        const currentName = item.name && item.name["ENG"] ? item.name["ENG"] : "";
        // Set editing state to true (boolean) instead of the value
        this.$set(this.editingName, item.id, true);
        // Store the actual value separately for the v-model
        this.$set(this.editingNameValue, item.id, currentName);
        // Store original value for potential rollback
        this.$set(this.originalName, item.id, currentName);
        this.$nextTick(() => {
          const refs = this.$refs.nameInput;
          if (refs && refs.length > 0) {
            refs[0].focus();
          } else {
            // Try to find the input element directly
            const input = document.querySelector(
              `[data-item-id="${item.id}"] input`
            );
            if (input) {
              input.focus();
            }
          }
        });
      },
    startEditingDescription(item) {
      const currentDescription =
        item.description && item.description["ENG"]
          ? item.description["ENG"]
          : "";
      // Set editing state to true (boolean) instead of the value
      this.$set(this.editingDescription, item.id, true);
      // Store the actual value separately for the v-model
      this.$set(this.editingDescriptionValue, item.id, currentDescription);
      // Store original value for potential rollback
      this.$set(this.originalDescription, item.id, currentDescription);
      this.$nextTick(() => {
        const refs = this.$refs.descriptionInput;
        if (refs && refs.length > 0) {
          refs[0].focus();
        } else {
          // Try to find the textarea element directly
          const textarea = document.querySelector(
            `[data-item-id="${item.id}"] textarea`
          );
          if (textarea) {
            textarea.focus();
          }
        }
      });
    },
    startEditingDifficulty(item) {
      this.$set(this.editingDifficulty, item.id, true);
      this.$set(this.originalDifficulty, item.id, item.difficulty);
      this.$nextTick(() => {
        const refs = this.$refs.difficultyInput;
        if (refs && refs.length > 0) {
          refs[0].focus();
        }
      });
    },
    startEditingGoal(item) {
      this.$set(this.editingGoal, item.id, true);
      this.$set(this.originalGoal, item.id, item.goal);
      this.$nextTick(() => {
        const refs = this.$refs.goalInput;
        if (refs && refs.length > 0) {
          refs[0].focus();
        }
      });
    },
    startEditingType(item) {
      this.$set(this.editingType, item.id, true);
      this.$set(this.originalType, item.id, item.type);
      this.$nextTick(() => {
        const refs = this.$refs.typeInput;
        if (refs && refs.length > 0) {
          refs[0].focus();
        }
      });
    },
    startEditingGenBodyArea(item) {
      this.$set(this.editingGenBodyArea, item.id, true);
      this.$set(this.originalGenBodyArea, item.id, item.genBodyArea);
      this.$nextTick(() => {
        const refs = this.$refs.genBodyAreaInput;
        if (refs && refs.length > 0) {
          refs[0].focus();
        }
      });
    },
    startEditingSpecMuscleGr(item) {
      this.$set(this.editingSpecMuscleGr, item.id, true);
      this.$set(this.originalSpecMuscleGr, item.id, item.specMuscleGr);
      this.$nextTick(() => {
        const refs = this.$refs.specMuscleGrInput;
        if (refs && refs.length > 0) {
          refs[0].focus();
        }
      });
    },
    startEditingOneGymPlacement(item) {
      this.$set(this.editingOneGymPlacement, item.id, true);
      this.$set(this.originalOneGymPlacement, item.id, item.oneGymPlacement);
      this.$nextTick(() => {
        const refs = this.$refs.oneGymPlacementInput;
        if (refs && refs.length > 0) {
          refs[0].focus();
        }
      });
    },
    startEditingAccessory(item) {
      this.$set(this.editingAccessory, item.id, true);
      this.$set(this.originalAccessory, item.id, item.accessory);
      this.$nextTick(() => {
        const refs = this.$refs.accessoryInput;
        if (refs && refs.length > 0) {
          refs[0].focus();
        }
      });
    },
    startEditingTwoHands(item) {
      this.$set(this.editingTwoHands, item.id, true);
      this.$set(this.originalTwoHands, item.id, item.twoHands);
      this.$nextTick(() => {
        const refs = this.$refs.twoHandsInput;
        if (refs && refs.length > 0) {
          refs[0].focus();
        }
      });
    },
    // Save and cancel methods for name and description
    async saveName(item) {
      const newName = this.editingNameValue[item.id];
      const currentNameObj = { ...item.name };
      const currentName = item.name && item.name["ENG"] ? item.name["ENG"] : "";
      if (newName && newName.trim() !== currentName) {
        try {
          // Ensure name object exists
          if (!item.name) {
            this.$set(item, "name", {});
          }
          // Update the local item first
          this.$set(item.name, "ENG", newName.trim());
          await this.updateValue(item, "name", {...currentNameObj, ENG: newName.trim()});
        } catch (error) {
          console.error("Error saving name:", error);
        }
      }
      this.$delete(this.editingName, item.id);
      this.$delete(this.editingNameValue, item.id);
      this.$delete(this.originalName, item.id);
    },
    async saveDescription(item) {
      const newDescription = this.editingDescriptionValue[item.id];
      const currentDescriptionObj = { ...item.description };
      const currentDescription =
        item.description && item.description["ENG"]
          ? item.description["ENG"]
          : "";
      if (newDescription !== currentDescription) {
        try {
          // Ensure description object exists
          if (!item.description) {
            this.$set(item, "description", {});
          }
          // Update the local item first
          this.$set(item.description, "ENG", newDescription);
          await this.updateValue(item, "description", {...currentDescriptionObj, ENG: newDescription});
        } catch (error) {
          console.error("Error saving description:", error);
        }
      }
      this.$delete(this.editingDescription, item.id);
      this.$delete(this.editingDescriptionValue, item.id);
      this.$delete(this.originalDescription, item.id);
    },
    cancelEditingName(item) {
      // Restore original value
      if (this.originalName[item.id] !== undefined) {
        if (!item.name) {
          this.$set(item, "name", {});
        }
        this.$set(item.name, "ENG", this.originalName[item.id]);
        this.$delete(this.originalName, item.id);
      }
      this.$delete(this.editingName, item.id);
      this.$delete(this.editingNameValue, item.id);
    },
    cancelEditingDescription(item) {
      // Restore original value
      if (this.originalDescription[item.id] !== undefined) {
        if (!item.description) {
          this.$set(item, "description", {});
        }
        this.$set(item.description, "ENG", this.originalDescription[item.id]);
        this.$delete(this.originalDescription, item.id);
      }
      this.$delete(this.editingDescription, item.id);
      this.$delete(this.editingDescriptionValue, item.id);
    },
    // Save methods
    async saveDifficulty(item) {
      const originalValue = this.originalDifficulty[item.id];
      if (item.difficulty !== originalValue) {
        try {
          await this.updateValue(item, "difficulty", item.difficulty);
        } catch (error) {
          console.error("Error saving difficulty:", error);
        }
      }
      this.$delete(this.editingDifficulty, item.id);
      this.$delete(this.originalDifficulty, item.id);
    },
    async saveGoal(item) {
      const originalValue = this.originalGoal[item.id];
      if (item.goal !== originalValue) {
        try {
          await this.updateValue(item, "goal", item.goal);
        } catch (error) {
          console.error("Error saving goal:", error);
        }
      }
      this.$delete(this.editingGoal, item.id);
      this.$delete(this.originalGoal, item.id);
    },
    async saveType(item) {
      const originalValue = this.originalType[item.id];
      if (item.type !== originalValue) {
        try {
          await this.updateValue(item, "type", item.type);
        } catch (error) {
          console.error("Error saving type:", error);
        }
      }
      this.$delete(this.editingType, item.id);
      this.$delete(this.originalType, item.id);
    },
    async saveGenBodyArea(item) {
      const originalValue = this.originalGenBodyArea[item.id];
      if (item.genBodyArea !== originalValue) {
        try {
          await this.updateValue(item, "genBodyArea", item.genBodyArea);
        } catch (error) {
          console.error("Error saving genBodyArea:", error);
        }
      }
      this.$delete(this.editingGenBodyArea, item.id);
      this.$delete(this.originalGenBodyArea, item.id);
    },
    async saveSpecMuscleGr(item) {
      const originalValue = this.originalSpecMuscleGr[item.id];
      if (item.specMuscleGr !== originalValue) {
        try {
          await this.updateValue(item, "specMuscleGr", item.specMuscleGr);
        } catch (error) {
          console.error("Error saving specMuscleGr:", error);
        }
      }
      this.$delete(this.editingSpecMuscleGr, item.id);
      this.$delete(this.originalSpecMuscleGr, item.id);
    },
    async saveOneGymPlacement(item) {
      const originalValue = this.originalOneGymPlacement[item.id];
      if (item.oneGymPlacement !== originalValue) {
        try {
          await this.updateValue(item, "oneGymPlacement", item.oneGymPlacement);
        } catch (error) {
          console.error("Error saving oneGymPlacement:", error);
        }
      }
      this.$delete(this.editingOneGymPlacement, item.id);
      this.$delete(this.originalOneGymPlacement, item.id);
    },
    async saveAccessory(item) {
      const originalValue = this.originalAccessory[item.id];
      if (item.accessory !== originalValue) {
        try {
          await this.updateValue(item, "accessory", item.accessory);
        } catch (error) {
          console.error("Error saving accessory:", error);
        }
      }
      this.$delete(this.editingAccessory, item.id);
      this.$delete(this.originalAccessory, item.id);
    },
    async saveTwoHands(item) {
      const originalValue = this.originalTwoHands[item.id];
      if (item.twoHands !== originalValue) {
        try {
          await this.updateValue(item, "twoHands", item.twoHands);
        } catch (error) {
          console.error("Error saving twoHands:", error);
        }
      }
      this.$delete(this.editingTwoHands, item.id);
      this.$delete(this.originalTwoHands, item.id);
    },
    async updateValue(exercise, key, value) {
      const vm = this;

      // Store original value for rollback in case of error
      const originalValue = exercise[key];

      // Update local data immediately for better UX
      vm.$set(exercise, key, value);

      try {
        // Update database in background
        await vm.$store.dispatch("UpdateExerciseField", {
          id: exercise.id,
          fieldName: key,
          value: value,
          collectionName: exercise.collectionName,
        });

        await vm.$store.dispatch("GenerateLog", {
          id: exercise.id,
          title: exercise.name["ENG"],
          type: "editedExercise",
        });

        let emitData = {
          snackbar: true,
          btn: "",
          y: "bottom",
          x: null,
          mode: "",
          timeout: 2000,
          text: "Exercise updated successfully",
          color: "success",
        };
        vm.$emit("showSnackBar", emitData);
      } catch (error) {
        // Rollback local changes if database update fails
        vm.$set(exercise, key, originalValue);

        console.error("Error updating exercise:", error);

        let emitData = {
          snackbar: true,
          btn: "",
          y: "bottom",
          x: null,
          mode: "",
          timeout: 2000,
          text: "Error updating exercise",
          color: "error",
        };
        vm.$emit("showSnackBar", emitData);
      }
    },
  },
  destroyed() {
    let vm = this;
    // vm.$store.dispatch("GoUnsubscribeExercisesModule", "exercise");
  },
  computed: {
    ...mapGetters(["getExercises"]),
  },
  watch: {
    options: {
      handler() {
        console.log(this.options);
      },
      deep: true,
    },
    // itemsPerPage:{
    //   handler(newValue){
    //     this.getFirstPage()
    //   }
    // }
  },
  beforeRouteLeave(to, from, next) {
    console.log(to);
    if (to.name === "Edit Exercise") {
      const currentState = JSON.stringify({
        hitsPerPage: this.itemsPerPage,
        query: this.search,
        page: this.page,
      });
      localStorage.setItem("exercisesTableState", currentState);
    } else {
      localStorage.removeItem("exercisesTableState");
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === "Edit Exercise") {
      to.params.previousRoute = from.name;
    }
    next();
  },
};
</script>
<style scoped>
.v-data-table /deep/ .sticky-header {
  position: sticky;
  top: var(--toolbarHeight);
}

.v-data-table /deep/ .v-data-table__wrapper {
  overflow: unset;
}

.editable-field {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.editable-field:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.editable-input {
  max-width: 100%;
}

.editable-input /deep/ .v-input__control {
  min-height: auto;
}

.editable-input /deep/ .v-input__slot {
  min-height: 32px;
}

.nameSlot {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.nameSlot:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.descriptionSlot {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.descriptionSlot:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>